import { Container, type ContainerProps } from '@doist/marketist';
import cn from 'clsx';
import css from './container-sidebar.module.css';
import type { HTMLAttributes } from 'react';
type ContainerSidebarChildren = ContainerProps & {
  children: React.ReactNode;
  sidebarChildren?: React.ReactNode;
  className?: string;
  tag?: React.ElementType;
  width?: ContainerProps['width'];
};
export function ContainerSidebar({
  children,
  className,
  tag,
  width = 'lg',
  ...rest
}: ContainerSidebarChildren) {
  return <Container className={cn(css.containerSidebar, css[width], className)} tag={tag} width={width} {...rest} data-sentry-element="Container" data-sentry-component="ContainerSidebar" data-sentry-source-file="container-sidebar.tsx">
            {children}
        </Container>;
}
type ContainerSidebarMainProps = HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  className?: string;
};
ContainerSidebar.Main = function ContainerSidebarMain({
  children,
  className
}: ContainerSidebarMainProps) {
  return <div className={cn(css.main, className)}>{children}</div>;
};
type ContainerSidebarAsideProps = {
  children?: React.ReactNode;
  className?: string;
  tag?: React.ElementType;
};
ContainerSidebar.Aside = function ContainerSidebarAside({
  children,
  className,
  tag: Tag = 'div'
}: ContainerSidebarAsideProps) {
  return <Tag className={className}>{children}</Tag>;
};